import { ITestCase } from "../types/interfaces/testCase.interface";
import apiService, { ExportApi } from "./api.service";
import digitalApiService from "./digitalApi.service";
import store from "../store/store";
import { toggleAlert } from "../store/resuders/app.reducer";
import { CHANNELS } from "../types/global.enum";
import { getVoiceApi } from "./config.service";

export const getProjectList = async (pageNo = 0, pageSize = 10, sort = '', filter = '') => {
    const { data } = await apiService.get(`/projects?pageSize=${pageSize}&pageNo=${pageNo}&filter=${filter}${sort ? '&sortBy=' + encodeURIComponent(sort) : ''}`);
    return data;
}

export const getAllProjectList = async () => {
    const { data } = await apiService.get(`/projects/list`);
    return data;
}


export const getProjectById = async (projectId = 1) => {
    const { data } = await apiService.get(`/projects/${projectId}`);
    return data;
}

export const getSegments = async (id: any, channel: CHANNELS, pageSize = 5, pageNo = 1, language = '', filter = '') => {
    const lngFilter = language ? `&language=${language}`:'';
    const filterCriteria = filter ? `&filter=${filter}`:'';
    const { data } = channel === CHANNELS.DIGITAL ? await digitalApiService.get(`/projects/${id}/segments?includeStep=true&pageSize=${pageSize}&pageNo=${pageNo - 1}${filterCriteria}`) :
        await apiService.get(`/projects/${id}/segments?includeStep=true&pageSize=${pageSize}&pageNo=${pageNo - 1}${lngFilter}${filterCriteria}`);

    return data;
}

export const importData = async (id: number, type: string, language: string, file: any) => {
const formdata = new FormData();
if (file instanceof File) {
    formdata.append("document", file);
}
if (typeof language === "string" && language.trim() !== "") {
    formdata.append("lang", language);
}
// Get the token (ensure it's retrieved correctly from your auth system)
const token = localStorage.getItem('TOKEN'); // Example: Replace with your token retrieval logic
if (!token) {
    console.error('Authentication token is missing!');
}
console.log(language);

    let requestOptions = {
        method: 'POST',
        body: formdata,
        headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
    } as any;
    const url = `${getVoiceApi()}/projects/${id}/${type.toLowerCase()}/import`;

    return new Promise((res) => {
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => res(result))
            .catch(error => res(error));

    })


}

export const exportDataTypes = async (id: number, type: string) => {
    const { data } = await apiService.get(`/projects/${id}/${type}/export`);
    return data;
}

export const deleteProjects = async (id: number[]) => {
    await Promise.all(
        id.map(async i => {

            await apiService.delete(`/projects/${i}`);

            return true;
        })
    )
}

export const exportProjects = async (id: number[]) => {
    await Promise.all(
        id.map(async i => {
            try {
                const response = await ExportApi.get(`/projects/${i}/export`, {
                    responseType: 'json', // Ensure the response is JSON
                });
        
                // Convert the response data to a JSON Blob
                const jsonBlob = new Blob([JSON.stringify(response.data, null, 2)], { type: 'application/json' });
        
                // Create a temporary URL for the Blob
                const url = URL.createObjectURL(jsonBlob);
        
                // Create a temporary anchor element to trigger the download
                const a = document.createElement('a');
                a.href = url;
                a.download = `project_${i}_export.json`; // Set the file name
                document.body.appendChild(a); // Append the anchor to the body
                a.click(); // Trigger the download
                document.body.removeChild(a); // Remove the anchor from the body
        
                // Revoke the temporary URL to free up resources
                URL.revokeObjectURL(url);
        
                return true;
            } catch (error) {
                console.error('Error exporting project data:', error);
                return false;
            }
        })
    )
}



export const importProjectData = async (file: any) => {
    const formdata = new FormData();
    if (file instanceof File) {
        formdata.append("file", file);
    }
    
    // Get the token (ensure it's retrieved correctly from your auth system)
    const token = localStorage.getItem('TOKEN'); // Example: Replace with your token retrieval logic
    if (!token) {
        console.error('Authentication token is missing!');
    }
    
        let requestOptions = {
            method: 'POST',
            body: formdata,
            headers: {
                Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
        } as any;
        const url = `${getVoiceApi()?.replace('/voice/v1', '/v1/')}projects/import`;
    
        return new Promise((res) => {
            fetch(url, requestOptions)
                .then(response => response.json())
                .then(result => res(result))
                .catch(error => res(error));
    
        })
    
    
    }


export const upsertProject = async (data: any) => {

    if (data.testProjectID) {
        return await apiService.put(`/projects/${data.testProjectID}`, {
            ...data,
        }).catch(e => e);
    } else {
        return await apiService.post(`/projects`, {
            ...data,
        }).catch(e => e);
    }
}

export const getLanguages = async () => {
    const { data } = await apiService.get(`/languageCode`);

    return data?.data;
}

export const getGoToTypes = async () => {
    const { data } = await apiService.get(`/GoToType`);

    return data?.data;
}

export const getStepTypes = async () => {
    const { data } = await apiService.get(`/stepTypes`);

    return data?.data;
}

export const getNoises = async () => {
    const { data } = await apiService.get(`/noiseBackgrounds`);

    return data?.data;
}

export const getDigitalStepTypes = async () => {
    const { data } = await digitalApiService.get(`/stepTypes`);

    return data?.data;
}

export const getOperations = async () => {
    const { data } = await digitalApiService.get(`/matchOperations`);

    return data?.data;
}

export const getBrowsers = async () => {
    const { data } = await digitalApiService.get(`/browserTypes`);

    return data?.data;
}




export const getLocatorTypes = async () => {
    const { data } = await digitalApiService.get(`/htmlLocatorTypes`);

    return data?.data;
}


export const getBasicActions = async () => {
    const { data } = await apiService.get(`/virtualAgent/basicActions`);

    return data?.data?.basicActionResponseDTOList || [];
}


export const getScheduleTypes = async () => {
    const { data } = await apiService.get(`/schedules/types`);

    return data?.data;
}